import { Archive, File, FileImage, FileSpreadsheet, FileText, FileVideo, Folder, Music, Presentation, FileType2 } from "lucide-react";
import { fileKind } from "@/lib/api";

const MAP = {
  pdf: [FileType2, "text-red-600 bg-red-50"],
  image: [FileImage, "text-emerald-600 bg-emerald-50"],
  video: [FileVideo, "text-fuchsia-700 bg-fuchsia-50"],
  audio: [Music, "text-pink-600 bg-pink-50"],
  word: [FileText, "text-blue-700 bg-blue-50"],
  sheet: [FileSpreadsheet, "text-green-700 bg-green-50"],
  slides: [Presentation, "text-orange-600 bg-orange-50"],
  text: [FileText, "text-slate-600 bg-slate-100"],
  archive: [Archive, "text-amber-700 bg-amber-50"],
  other: [File, "text-slate-500 bg-slate-100"],
};

export const FileIcon = ({ file, folder = false, size = "md" }) => {
  const [I, cls] = folder ? [Folder, "text-[#1E3A8A] bg-blue-50"] : MAP[fileKind(file)];
  const box = size === "lg" ? "h-12 w-12" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const ic = size === "lg" ? "h-6 w-6" : size === "sm" ? "h-3.5 w-3.5" : "h-4.5 w-4.5";
  return (
    <span className={`${box} ${cls} rounded-md flex items-center justify-center shrink-0`}>
      <I className={ic} style={size === "md" ? { width: 18, height: 18 } : undefined} fill={folder ? "currentColor" : "none"} fillOpacity={folder ? 0.15 : 0} />
    </span>
  );
};
